import { css } from 'styled-components';
import { inlineMediaQueryMixin } from '../inlineMediaQueryMixin';
import { semanticChildrenMixin } from '../semanticChildrenMixin';
import { spacingMixin } from '../spacingMixin';
import { typographyMixin } from '../typographyMixin';
var textAlignCss = function textAlignCss(_ref) {
  var textAlign = _ref.textAlign;
  return textAlign ? css(["text-align:", ";"], textAlign) : '';
};
var textWrapCss = function textWrapCss(_ref2) {
  var textWrap = _ref2.textWrap;
  return textWrap ? css(["text-wrap:", ";"], textWrap) : '';
};

/** @class TextMixin */
/** @method */
export var TextMixin = function TextMixin(props) {
  return css(["", " ", " ", " margin:0;", " ", ""], typographyMixin(props), inlineMediaQueryMixin('textAlign', textAlignCss)(props), inlineMediaQueryMixin('textWrap', textWrapCss)(props), spacingMixin(props), semanticChildrenMixin(props));
};